import { Column, Row } from '@/components'
import { ThemeColor } from '@/enums'
import { themeColor, themeTransition } from '@/utils'
import styled from 'styled-components'
import { ifProp } from 'styled-tools'

export const MessagesContainer = styled(Column)`
  gap: 16px;
  padding-top: 16px;
`

export const ComposeToggleRow = styled(Row)`
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const ComposeContainer = styled(Column)<{ $isDragOver?: boolean }>`
  gap: 8px;
  padding: 16px;
  margin-bottom: 8px;
  border: 1px dashed
    ${ifProp(
      '$isDragOver',
      themeColor(ThemeColor.info1),
      themeColor(ThemeColor.b30),
    )};
  border-radius: 16px;
  background-color: ${ifProp(
    '$isDragOver',
    themeColor(ThemeColor.info4),
    'transparent',
  )};
  transition: ${themeTransition()};
`

export const ReplyBanner = styled(Row)`
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: ${themeColor(ThemeColor.info4)};
`

export const ComposeActions = styled(Row)`
  justify-content: space-between;
  align-items: center;
`

export const AttachmentsRow = styled(Row)`
  flex-wrap: wrap;
  gap: 8px;
`

export const AttachmentChip = styled(Row)`
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 100px;
  border: 1px solid ${themeColor(ThemeColor.b30)};
  max-width: 220px;
`

export const RemoveAttachmentButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${themeColor(ThemeColor.b50)};
`

export const MessageList = styled(Column)`
  gap: 8px;
`

export const MessageCard = styled(Column)<{ $isOpen?: boolean }>`
  padding: 16px;
  border-radius: 16px;
  border: 1px solid
    ${ifProp(
      '$isOpen',
      themeColor(ThemeColor.info1),
      themeColor(ThemeColor.b30),
    )};
  background-color: ${ifProp(
    '$isOpen',
    themeColor(ThemeColor.info4),
    'transparent',
  )};
  transition: ${themeTransition()};
`

export const MessageTitleColumn = styled(Column)`
  width: 100%;
  gap: 6px;
`

export const MessageCardHeader = styled(Row)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`

export const MessageDateColumn = styled(Column)`
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
`

export const ReplyButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${themeColor(ThemeColor.info1)};
  font: inherit;
  font-size: 12px;
`

export const ContactLine = styled(Row)`
  align-items: center;
  gap: 8px;
  min-width: 0;
`

export const MessageIcons = styled(Row)`
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  color: ${themeColor(ThemeColor.b50)};
`

export const UnreadDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${themeColor(ThemeColor.info1)};
`

export const MessageMeta = styled(Column)`
  gap: 4px;
  padding-top: 12px;
`

export const MessageMetaRow = styled(Row)`
  justify-content: space-between;
  gap: 16px;
`

export const MessageBody = styled.div`
  padding-top: 12px;
  line-height: 1.5;
`

export const MessageAttachments = styled(Column)`
  gap: 6px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid ${themeColor(ThemeColor.b30)};
`

export const MessageAttachmentRow = styled(Row)`
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: ${themeColor(ThemeColor.b50)};
`

export const MessageAttachmentDownload = styled.button`
  display: flex;
  align-items: center;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${themeColor(ThemeColor.info1)};
  flex-shrink: 0;
`

export const LoadMoreRow = styled(Row)`
  justify-content: center;
  padding: 8px 0;
`
